import { render } from "./companyDetailModal.vue?vue&type=template&id=62d2b3d2"
import script from "./companyDetailModal.vue?vue&type=script&lang=js"
export * from "./companyDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__